import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=80340616&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"
import style0 from "./Accordion.vue?vue&type=style&index=0&id=80340616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../build/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80340616",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/sw-41f73918-1793878079/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('80340616')) {
      api.createRecord('80340616', component.options)
    } else {
      api.reload('80340616', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=80340616&scoped=true&", function () {
      api.rerender('80340616', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "www/roadrunner/Application/ViewComponents/Accordion/Accordion.vue"
export default component.exports